
import AllDeclineReasons from '../features/admin/components/DeclineReasons/AllDeclineReasons'

function DeclineReasons() {
  return (
    <><AllDeclineReasons/></>
  )
}

export default DeclineReasons